// src/DoctorDetails.jsx
import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { confirm } from './confirm';
import moment from "moment";
import "./tokenlyglobal.css";

const DoctorDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [doctor, setDoctor] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [user, setUser] = useState(null);

  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);

    const stored = localStorage.getItem("tokenly_user");
    if (stored) {
      try {
        const parsed = JSON.parse(stored);
        setUser(parsed);
      } catch {
        setUser(null);
      }
    } else {
      setUser(null);
    }

    const fetchDoctor = async () => {

      console.log("user", user);
      try {
        setLoading(true);
        setError("");

        const res = await fetch("https://tokenly.biswaas.com/api/doctor-detail", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            itemId: Number(id),
          }),
        });

        if (!res.ok) throw new Error("Failed to load doctor");

        const json = await res.json();
        setDoctor(json.data);
      } catch (e) {
        setError(e.message || "Error fetching doctor details");
      } finally {
        setLoading(false);
      }
    };

    fetchDoctor();
  }, [id]);

  const startPaytmPayment = async () => {

    if (typeof user.userId == 'undefined' || user.userId == null) {
      navigate("/login");
      return;
    }


    const orderId = "ORD_" + Date.now();
    const amount = "5.00";
    const res = await fetch("https://tokenly.biswaas.com/api/paytm/initiate", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        orderId: orderId,
        amount: amount,
        userId: user.userId,
      }),
    });

    const data = await res.json();

    if (!data.data.txnToken) {
      alert("Failed to get Paytm token");
      return;
    }

    openPaytmCheckout(orderId, data.data.txnToken, amount);
  };

  const openPaytmCheckout = (orderId, txnToken, amount) => {

    const config = {
      root: "",
      flow: "DEFAULT",
      data: {
        orderId: orderId,
        token: txnToken,
        tokenType: "TXN_TOKEN",
        amount: amount,
      },
      handler: {
        notifyMerchant: function (eventName, data) {
          console.log("Paytm Event:", eventName, data);
        },
      },
    };

    if (window.Paytm && window.Paytm.CheckoutJS) {
      window.Paytm.CheckoutJS.init(config)
        .then(() => {
          window.Paytm.CheckoutJS.invoke();
        })
        .catch((error) => {
          console.error("Paytm init error", error);
        });
    } else {
      alert("Paytm CheckoutJS not loaded");
    }
  };

  const getAuthToken = () => {
    return localStorage.getItem("tokenly_token") || "";
  };

  const tokenBook = async (data) => {

    const authToken = getAuthToken();
    console.log("authToken", authToken);
    if (!authToken) {

      const redirectBackUrl = '/doctor/' + data.doctorId;
      console.log("redirectBackUrl--------", redirectBackUrl);
      document.cookie = `redirectBackUrl=${encodeURIComponent(redirectBackUrl)}; path=/`;

      setError("Please login first.");
      navigate("/login");
      return;
    }

    const tokenRes = await fetch("https://tokenly.biswaas.com/api/doctor/genrateToken", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${getAuthToken()}`
      },
      body: JSON.stringify({
        itemId: data.doctorId,
        shift: data.shift,
        shift_time: data.shift_time,
        action: data.action,
      }),
    });

    const json = await tokenRes.json();

    if (!json.status) {

      let msg = json.message;
      if (msg == 'Low Balance') {
        //alert('you may not have enough balance to generate token');

        const confirmed = window.confirm('you may not have enough balance to generate token, Please pay 5 rupee for book token');

        if (confirmed) {

          const redirectBackUrl = '/doctor/' + data.doctorId;
          console.log("redirectBackUrl--------", redirectBackUrl);
          document.cookie = `redirectBackUrl=${encodeURIComponent(redirectBackUrl)}; path=/`;
          startPaytmPayment();
          console.log("User clicked OK");
        } else {
          console.log("User clicked Cancel");
        }
        //payNow(5, itemId, shift, isShiftCheck, hoursDetail);
        //setLoading(false);
      } else if (msg.includes('You have token no')) {

        console.log("aaaaaaaaaa");

        const confirmed = window.confirm(msg);

        if (confirmed) {
          console.log("User clicked OK");
          tokenBook({
            doctorId: data.doctorId,
            shift: data.shift,
            shift_time: data.shift_time,
            clinicName: data.clinicName,
            doctorName: data.doctorName,
            action: 'Duplicate Token'
          });
        } else {
          console.log("User clicked Cancel");
        }


      } else {
        alert(json.message || "Token generation failed");
      }
      return false;
    } else {
      navigate(`/token-receipt/${data.doctorId}`, {
        state: { tokenData: json.data, doctorData: data },
      });
      return true;
    }
  };

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '60vh' }}>
        <div className="text-center">
          <div className="spinner-border text-primary" role="status" style={{ width: '3rem', height: '3rem' }}>
            <span className="visually-hidden">Loading...</span>
          </div>
          <p className="mt-3 text-muted">Loading doctor details...</p>
        </div>
      </div>
    );
  }

  if (error || !doctor) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '60vh' }}>
        <div className="text-center text-danger">
          <i className="fas fa-exclamation-triangle fa-3x mb-3"></i>
          <p>{error || "Doctor not found"}</p>
        </div>
      </div>
    );
  }

  const {
    fullname,
    name_title,
    clinic_name,
    street_address,
    profile_photo_full,
    specialties,
    hours_detail,
    tokenQueue,
    doc_fees,
    clinic_phone,
    reg_num,
    offDays,
    remark_text,
    phone,
  } = doctor;

  const displayName = name_title ? `${name_title} ${fullname}` : fullname;

  const specialityArr =
    specialties && specialties !== "null" ? JSON.parse(specialties) : [];
  const primarySpeciality = specialityArr[0] || "Doctor";

  const todaySlots = hours_detail?.time || [];
  const todaySloat = doctor.today_sloat ? JSON.parse(doctor.today_sloat) : [];
  const queueCount = tokenQueue ?? 0;
  const closingText =
    Array.isArray(offDays) && offDays.length > 0
      ? offDays[0]
      : "No upcoming holidays";

  return (
    <div id="doctor-profile-view" className="bg-light min-vh-100 d-flex justify-content-center align-items-center py-4 py-md-5">
      <div className="container px-2 px-md-4" style={{ maxWidth: "700px", width: "100%" }}>




        {/* Unified Single Card */}
        <div className="card border-0 shadow-lg rounded-4 overflow-hidden">
          {/* Header Section */}
          <div className="card-header bg-white border-0 p-3 p-md-4 pb-0">
            <div className="d-flex align-items-center mb-3">
              <div className="me-3 position-relative">
                {profile_photo_full ? (
                  <img
                    src={profile_photo_full}
                    alt={displayName}
                    className="rounded-circle shadow-sm"
                    style={{ width: "80px", height: "80px", objectFit: "cover", border: "3px solid #f8f9fa" }}
                  />
                ) : (
                  <div className="rounded-circle bg-light d-flex align-items-center justify-content-center" style={{ width: "80px", height: "80px" }}>
                    <i className="fa-solid fa-user-doctor fa-2x text-secondary"></i>
                  </div>
                )}
              </div>

              <div className="flex-grow-1">
                <h4 className="fw-bold text-dark mb-1">{displayName}</h4>
                <div className="d-flex flex-wrap gap-2 text-muted small align-items-center">
                  <span className="badge bg-primary-subtle text-primary border border-primary-subtle rounded-pill">
                    {primarySpeciality}
                  </span>
                  <span>•</span>
                  <span>{doc_fees != null ? `₹${doc_fees}` : "Fees N/A"}</span>
                  <span>•</span>
                  <span className="text-success fw-semibold">
                    Patients in Queue: {queueCount}
                  </span>
                </div>
              </div>
            </div>

            {/* Clinic Info Row */}
            <div className="bg-light rounded-3 p-2 px-3 mb-2 d-flex justify-content-between align-items-center">
              <div>
                <h6 className="fw-bold mb-1 text-dark">{clinic_name}</h6>
                <p className="text-muted small mb-0 lh-sm"><i className="fas fa-map-marker-alt me-1 text-danger"></i> {street_address || "Address not available"}</p>
              </div>
              <a
                href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(street_address || "")}`}
                target="_blank"
                rel="noreferrer"
                className="btn btn-white bg-white border shadow-sm btn-sm rounded-circle d-flex align-items-center justify-content-center"
                style={{ width: '36px', height: '36px' }}
                title="View on Map"
              >
                <i className="fa-solid fa-diamond-turn-right text-primary"></i>
              </a>
            </div>
          </div>

          <div className="card-body p-3 p-md-4 pt-2">

            {/* Status & Slots Header */}
            <div className="d-flex flex-wrap justify-content-between align-items-center mb-3 gap-2">
              <div className="d-flex flex-column flex-sm-row align-items-sm-center gap-2">
                <h6 className="fw-bold mb-0">Today's Slots</h6>
                <span className="badge bg-primary-subtle text-primary border border-primary-subtle rounded-pill">
                  <i className="fas fa-hand-point-down me-1"></i> Click On Time Slot to generate token
                </span>
              </div>
              <span className={`badge ${doctor?.current_token !== null ? 'bg-success' : 'bg-danger'} rounded-pill`}>
                {doctor?.current_token !== null ? "Available" : "Ideal"}
              </span>
            </div>

            {/* Scrollable Slots Grid */}
            <div
              id="timeSlotContainer"
              className="custom-scrollbar mb-3"
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fill, minmax(85px, 1fr))',
                gap: '8px',
                maxHeight: '320px',
                overflowY: 'auto',
                paddingRight: '5px'
              }}
            >
              {todaySlots.map((slot, i) => {
                const sloatInfo = todaySloat.find(s => s.sloat === i);
                const isClosed = sloatInfo ? sloatInfo.isClosed : false;

                // Time-based logic (matches mobile app)
                const now = moment();
                const slotEnd = moment(slot.end_time, 'hh:mm A');

                let isTimeExpired = false;
                if (now.isAfter(slotEnd)) {
                  isTimeExpired = true;
                }

                const isDisabled = isClosed || isTimeExpired;

                return (
                  <button
                    key={i}
                    className={`btn btn-sm py-2 ${isDisabled ? 'btn-light text-muted border' : 'btn-outline-success'}`}
                    disabled={isDisabled}
                    style={{ borderRadius: '8px', fontSize: '0.85rem' }}
                    onClick={isDisabled ? undefined : () => tokenBook({
                      doctorId: doctor.id,
                      shift: i,
                      shift_time: `${slot.start_time} to ${slot.end_time}`,
                      clinicName: clinic_name,
                      doctorName: fullname,
                      action: 'Token'
                    })}
                  >
                    <strong>{slot.start_time}</strong>
                    <span className="d-block" style={{ fontSize: '0.7rem' }}>- {slot.end_time}</span>
                  </button>
                );
              })}

              {!loading && todaySlots.length === 0 && (
                <div className="text-center py-4 w-100 grid-column-span-all">
                  <p className="text-muted small mb-0">No slots available.</p>
                </div>
              )}
            </div>

            <hr className="opacity-10 my-3" />

            {/* Bottom Details (Compact) */}
            <div className="row g-2 small text-muted">
              <div className="col-6">
                <strong className="d-block text-dark">Contact</strong>
                {clinic_phone || phone || "N/A"}
              </div>
              <div className="col-6">
                <strong className="d-block text-dark">Reg. No</strong>
                {reg_num || "N/A"}
              </div>
              {remark_text && (
                <div className="col-12 mt-2">
                  <div className="alert alert-warning border-0 bg-warning-subtle text-warning-emphasis p-2 mb-0 rounded-3 d-flex align-items-start gap-2">
                    <i className="fas fa-info-circle mt-1"></i>
                    <span className="lh-sm">{remark_text}</span>
                  </div>
                </div>
              )}
              {closingText && (
                <div className="col-12 mt-2">
                  <div className="alert alert-danger border-0 bg-danger-subtle text-danger p-2 mb-0 rounded-3">
                    <i className="fas fa-calendar-xmark me-2"></i> Upcoming Holiday: <strong>{closingText}</strong>
                  </div>
                </div>
              )}
            </div>

            {/* Back Button at Bottom */}
            <div className="mt-4 pt-3 border-top d-flex justify-content-center">
              <button
                className="btn btn-outline-secondary rounded-pill px-4 fw-bold"
                onClick={() => navigate(-1)}
              >
                <i className="fa-solid fa-arrow-left me-2"></i> Back
              </button>
            </div>

          </div>
        </div>
      </div>
    </div >
  );
};

export default DoctorDetails;
